import {
    createRouter,
    createWebHistory,
    RouteRecordRaw,
    NavigationGuardNext,
    RouteLocationNormalized,
} from "vue-router";

import HomeView from "../views/HomeView.vue";
import LoginView from "@/views/Authorization/LoginView.vue";
import CreateView from "@/views/CreateView.vue";

import { useAuth } from "@/composables/useAuth";
import EditView from "@/views/EditView.vue";
import DetailView from "@/views/DetailView.vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/:template",
        name: "Home",
        props: true,
        component: HomeView,
    },
    {
        path: "/:template/create",
        name: "Create",
        props: true,
        component: CreateView,
    },
    {
        path: "/:template/edit/:id",
        name: "Edit",
        props: true,
        component: EditView,
    },
    {
        path: "/:template/detail/:id",
        name: "Detail",
        props: true,
        component: DetailView,
    },
    {
        path: "/login",
        name: "Login",
        component: LoginView,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

// Initialize auth system
const auth = useAuth();

router.beforeEach(async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    // Allow access to login page
    if (to.name === "Login") {
        next();
        return;
    }

    // Initialize auth if not already done
    if (!auth.isInitialized.value) {
        await auth.initialize();
    }

    // Check if user is authenticated
    if (!auth.isAuthenticated.value) {
        // Save the intended destination
        sessionStorage.setItem("auth_return_url", to.fullPath);

        // Redirect to login handler
        next({ name: "Login" });
    } else {
        next();
    }
});

export default router;
